import { Messages } from "../../lib/locale";

export const Polish: Messages = {
  name: "Polski",
  helpTitle: "Jak grać",
  help1: `Każdego dnia pojawia się nowy Tajemniczy Kraj. Twoim zadaniem jest go odgadnąć przy jak najmniejszej liczbie prób. Każda nieprawidłowa odpowiedź pojawia się na kuli ziemskiej w kolorze wskazującym jak blisko jest do Tajemniczego Kraju. Im <b>cieplejszy</b> kolor, tym bliżej jesteś prawidłowej odpowiedzi.`,
  help2: `Na przykład, jeśli Tajemniczym Krajem jest <b>Japonia</b>, to poniższe kraje pojawią się w takich kolorach:`,
  help3: `Codziennie będzie dostępny nowy Tajemniczny Kraj!`,
  France: "Francja",
  Nepal: "Nepal",
  Mongolia: "Mongolia",
  "South Korea": "Korea Południowa",
  Aux1: `<b>["Kliknij", "Dotknij"]</b> kulę ziemską, żeby zagrać!`,
  Aux2: "Masz pytania?",
  Aux3: "Zobacz FAQ",
  Footer1: "stworzone przez The Abe Train",
  Footer2: "Podoba Ci się gra?",
  Footer3: "Kup mi kawę",
  Loading: "Ładowanie...",
  FAQTitle: "FAQ",
  q1: "1. Jak obliczana jest odległość pomiędzy zgadywaną a poprawną odpowiedzią?",
  a1: "Odległość pomiędzy krajami jest określona jako minimalna odległość między ich granicami na powierzchni Ziemi.",
  q2: "2. Jak mogę grać, jeśli jestem daltonistą lub osobą słabowidzącą?",
  a2: "W <button>Ustawieniach</button> można aktywować tryb dla daltonistów.",
  q3: "3. W jaki sposób gra decyduje, które terytoria są państwem?",
  a3: "Globle używa tego <a>frameworka</a>, aby określić, jakie terytorium uzna za kraj.",
  q4: "4. Czy w grze są autonomiczne, ale niesuwerenne kraje?",
  a4: "Niektóre terytoria pojawią się w neutralnym kolorze, gdy odgadnie się ich suwerenne państwo, np. Grenlandia dla Danii. Położenie tych terytoriów nie wpływa na kolor suwerennego państwa. Większość małych terytoriów nie pojawia się w grze, m.in. Curaçao.",
  q5: "5. Znalazłem dzisiejszy tajemniczy kraj! Kiedy mogę znowu zagrać?",
  a5: "Tajemniczy kraj zmienia się, a Twoje odpowiedzi resetują, o północy w Twojej strefie czasowej.",
  q6: "6. Czy dopuszczalne są alternatywne nazwy krajów?",
  a6: "Istnieje wiele krajów o wielu dopuszczalnych nazwach. Akceptowana jest pewna alternatywna pisownia i poprzednie nazwy, np. Burma dla Myanmar. Również w niektórych krajach zawierających wiele słów dopuszczalne są akronimy, np. UAE dla United Arabe Emirates (Zjednoczonych Emiratów Arabskich).",
  q7: "7. Brak kraju lub granica jest nieprawidłowa. Co mogę z tym zrobić?",
  a7: "Geografia może być delikatnym tematem, a granice niektórych krajów są sporne. Jeśli uważasz, że należy wprowadzić poprawki, dodaj proszę issue na {GitHub} lub napisz do mnie na {Twitter}.",
  GameTitle: "Gra",
  Game1: "Wpisz nazwę kraju",
  Game2: "Wpisz",
  Game3: "Wpisz nazwę jakiegoś kraju, aby zacząć grę",
  Game4: `Przeciągnij, <span>["kliknij", "dotknij"]</span> i powiększ kulę ziemską, żeby ułatwić sobie dalsze zgadywanie.`,
  Game5: "Nieprawidłowa nazwa",
  Game6: "Ten kraj już się pojawił",
  Game7: "Tajemniczy Kraj to {answer}!",
  Game8: "Najbliższa granica",
  StatsTitle: "Statystyki",
  Stats1: "Ostatnie zwycięstwo",
  Stats2: "Dzisiejsze próby",
  Stats3: "Wygrane gry",
  Stats4: "Wygrane gry z rzędu",
  Stats5: "Najwięcej wygranych gier z rzędu",
  Stats6: "Średnia liczba prób",
  Stats7: "Średnia liczba prób",
  Stats8: "Zresetuj",
  Stats9: "Udostępnij",
  Stats10: "Jesteś pewny, że chcesz zresetować swoje wyniki?",
  Stats11: "Statystyki zostały usunięte.",
  Stats12: "Skopiowane do schowka!",
  SettingsTitle: "Ustawienia",
  Settings1: "Tryb dzienny",
  Settings2: "Tryb nocny",
  Settings3: "Tryb dla daltonistów włączony",
  Settings4: "Tryb dla daltonistów wyłączony",
  Settings5: "Kraje",
  Settings6: "Miasta",
  Settings7: "Język",
  Settings8: "Globle: Miasta już wkrótce!",
  Settings9: "Trenuj",
  Settings10: "Tęcza aktywowana",
  Settings11: "Tęcza dezaktywowana",
  Answer: "Odpowiadać",
  Closest: "Najbliższy",
  Guessed: "Guessed", //TODO: Translate
  PracticeMode: "Jesteś w trybie ćwiczeń.",
  PracticeExit: "Wyjdź z trybu ćwiczeń",
  PracticeNew: "Nowa gra treningowa",
  SortByGuesses: "Sort by order of guesses", //TODO: Translate
  SortByDistance: "Sort by distance", //TODO: Translate
};
